import {z} from 'zod';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {IN_EUROPE, OUT_OF_EUROPE} from '../utils/const';

const paymentSettingsFormFields = z.object({
  paymentLimit: z.number().nullish(),
  allowBankTransfer: z.boolean(),
  allowElectronicInvoiceEmail: z.boolean(),
  allowAbroadSale: z.boolean().nullish(),
  abroadSale: z.array(z.enum([IN_EUROPE, OUT_OF_EUROPE])).nullish(),
  invoiceMaturity: z.number().nullish(),
  email: z.string().nullish(),
});

// Only for users who can edit these fields: a malformed stored record must not block an abroad sale save.
export const paymentSettingsFormSchema = (canEditBankTransferSettings: boolean) =>
  paymentSettingsFormFields.superRefine((values, context) => {
    if (!canEditBankTransferSettings) {
      return;
    }

    if (values.allowBankTransfer && isNil(values.invoiceMaturity)) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['invoiceMaturity'],
        message: i18n.t('general.validations.fieldIsRequired'),
      });
    }

    if (values.allowElectronicInvoiceEmail && isNilOrEmpty(values.email)) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['email'],
        message: i18n.t('general.validations.fieldIsRequired'),
      });
    }
  });

export type PaymentSettings = z.infer<typeof paymentSettingsFormFields>;
